import React from 'react';
import ChangeComboGroupPositionState from './changeComboGroupPositionState/ChangeComboGroupPositionState';
import ChangeComboGroupPosition from './components/ChangeComboGroupPosition/ChangeComboGroupPosition';

const ChangeComboGroupPositionPage: React.FC = () => {
	return (
		<ChangeComboGroupPositionState>
			<ChangeComboGroupPosition />
		</ChangeComboGroupPositionState>
	);
};

export default ChangeComboGroupPositionPage;
